import Button from "src/components/MyButton/Button"
import ListPurchase from "./component/ListPurchase"
import { useState } from "react"
import { message } from "antd"
import ReportsService from "src/services/ReportService"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import { ToolBarStyle } from "src/pages/ADMIN/HumanResource/Work/Task/styled"
import ReportPoolDataService from "src/services/ReportPoolDataService"
import PermissionGuard from "src/components/PermissionGuard"
const ReportReceiptM2M = props => {
  const [filter, setFilter] = useState({})
  const [refresh, setRefresh] = useState(false)
  const [keyword, setKeyword] = useState("")

  const handleExportExcel = async () => {
    try {
      console.log("Filter gửi sang export:", filter)
      const response = await ReportPoolDataService.exportExcelReportPackageReceiptM2M({
        filter: {
          ...filter,
          keyword: keyword
        },
      })

      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)

        // Tạo ngày giờ để thêm vào tên file
        const now = new Date()
        const pad = n => n.toString().padStart(2, "0")
        const dateStr = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
          now.getDate(),
        )}_${pad(now.getHours())}${pad(now.getMinutes())}`

        const link = document.createElement("a")
        link.href = url
        link.setAttribute(
          "download",
          `Danh_sach_bao_cao_nhap_kho_M2M_${dateStr}.xlsx`,
        )
        document.body.appendChild(link)
        link.click()

        link.remove()
        window.URL.revokeObjectURL(url)
      } else {
        message.error("Không có dữ liệu để xuất Excel.")
      }
    } catch (error) {
      console.error("Lỗi khi xuất Excel:", error)
      message.error("Xuất Excel thất bại.")
    }
  }

  return (
    <>
      {" "}
      <div>
        <WrapperStyle>
          <ToolBarStyle>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 4,
                marginBottom: 20,
                flexWrap: "wrap",
                gap: 8,
              }}
              className="px-2 p-md-0"
            >
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#005F90",
                  margin: 0,
                }}
              >
                BÁO CÁO MUA GÓI
              </h3>
            </div>
            <div style={{ marginLeft: "auto" }}>
              <Button btnType="primary1" onClick={handleExportExcel}>
                Xuất Excel
              </Button>
            </div>
            <div className="right-side d-none d-md-flex"></div>
            <div style={{ width: "100%" }} className="px-2 p-md-0">
              <PermissionGuard permission="poolData.reportPackage.listReceipt">
              <ListPurchase
                scroll={{ x: true }}
                setParentFilter={setFilter}
                filter={filter}
                refresh={refresh}
                setRefresh={setRefresh}
                setKeyword={setKeyword}
                keyword={keyword}
              />
              </PermissionGuard>
            </div>
          </ToolBarStyle>
        </WrapperStyle>
      </div>
    </>
  )
}
export default ReportReceiptM2M
